export default __webpack_public_path__ + "static/media/yellow_mark_icon.2f7c6417.svg";